import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './auth.guard';

export const AppRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
      },
      {
        path: 'starter',
        loadChildren: () => import('./starter/starter.module').then(m => m.StarterModule)
      },
      {
        path: 'components',
        loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule)
      },
      {
        path: 'models',
        loadChildren: () => import('./models/models.module').then(m => m.ModelsModule)
      },
      {
        path: 'eu',
        loadChildren: () => import('./eu/eu.module').then(m => m.EuModule)
      },
      {
        path: 'assets',
        loadChildren: () => import('./assets/assets.module').then(m => m.AssetsModule)
      }, {
        path: 'datasource',
        loadChildren: () => import('./datasources/datasources.module').then(m => m.DatasourcesModule)
      },
      // {
      //   path: 'alarms',
      //   loadChildren: () => import('./realtime-alarms/realtime-alarms.module').then(m => m.RealtimeAlarmsModule)
      // },
      {
        path: 'user-alarms',
        loadChildren: () => import('./realtime-alarms/realtime-alarms.module').then(m => m.RealtimeAlarmsModule)
      }, {
        path: 'perspectives',
        loadChildren: () => import('./perspectives/perspectives.module').then(m => m.PerspectivesModule)
      },{
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'user-management',
        loadChildren: () => import('./user-management/user-management.module').then(m => m.UserManagementModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./dropdowns/dropdown.module').then(m => m.DropdownModule)
      }
    ]
  },
];
